import React from 'react';

interface StepProgressProps {
  currentStep: number;
  steps: string[];
}

function StepProgress({ currentStep, steps }: StepProgressProps) {
  return (
    <div className="w-full flex justify-center">
      <div className="flex flex-row items-center w-full max-w-4xl">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className="flex items-center">
              <div className="relative flex flex-col items-center">
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full border-2 ${
                    currentStep > index
                      ? 'border-color-primary-300 bg-color-primary-300 text-white'
                      : 'border-color-primary-300 bg-white'
                  }`}
                >
                  {currentStep > index ? (
                    <span>&#10003;</span> // checkmark icon
                  ) : (
                    <span className="w-2 h-2 rounded-full bg-color-primary-300" />
                  )}
                </div>
                <span className="mt-2 text-sm text-center text-color-primary-300">
                  {step}
                </span>
              </div>
            </div>

            {/* Línea horizontal entre los pasos, excepto después del último */}
            {index < steps.length - 1 && (
              <div className="flex-1 h-px bg-color-primary-300 mx-2" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default StepProgress;
